module.exports = __webpack_public_path__ + "static/media/3.0f09b758.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/3.png
// module id = 1304
// module chunks = 0